import { isBrowser } from 'browser-or-node';

/**
 * requestIdleCallback() API
 * provides the ability to queue tasks to be executed automatically by the user agent
 * when it determines that there is free time to do so.
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Background_Tasks_API}
 */

export const requestIdleCallback = isBrowser && window?.requestIdleCallback || function(handler) {
  /** window.requestIdleCallback is not defined, use setTimeout as a shim function instead. */

  let startTime = Date.now();

  return setTimeout(function() {
    handler({
      didTimeout: false,
      timeRemaining: function() {
        return Math.max(0, 50.0 - (Date.now() - startTime));
      },
    });
  }, 1);
}

export const cancelIdleCallback = isBrowser && window?.cancelIdleCallback || function(id) {
  clearTimeout(id);
}
